
import { defineComponent, computed, ref } from "vue";
import { mapActions, mapState } from "vuex";
import { UserLoginData } from "@/types/interfaces";
import state from "@/store/state";

export default defineComponent({
  setup() {
    const username = ref("");
    const floatingStateUsername = computed(() => username.value.length >= 5);
    const floatingInvalidFeedbackUsername = computed(() =>
      username.value.length > 0 ? "Ingrese al menos 5 caracteres" : "Por favor ingrese algo"
    );

    const password = ref("");
    const floatingStatePassword = computed(() => password.value.length >= 4);
    const floatingInvalidFeedbackPassword = computed(() =>
      password.value.length > 0 ? "Ingrese al menos 4 caracteres" : "Por favor ingrese algo"
    );
    return {
      username,
      floatingInvalidFeedbackUsername,
      floatingStateUsername,
      floatingStatePassword,
      floatingInvalidFeedbackPassword,
      password,
    };
  },

  data() {
    return {
      userData: { username: null, password: null },
      isDisabled: true,
      isWrong: false,
    };
  },
  name: "Login",
  methods: {
    ...mapActions(["login"]),
    ...mapState(["isProfessor", "isAdmin", "isStudent"]),
    checkForm() {
      if (this.username.length > 4 && this.password.length >= 4) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    },
    async handleLogin() {
      if (this.username !== "" && this.password !== "") {
        const userData: UserLoginData = {
          username: this.username,
          password: this.password,
        };
        try {
          await this.login(userData);
          this.isWrong = false;
          if (state.isStudent === true) {
            this.$router.push({ path: `/student/${state.currentUser.id}` });
          } else if (state.isProfessor === true) {
            this.$router.push("/teacher");
          } else if (state.isAdmin === true) {
            this.$router.push("/admin");
          }
        } catch (error) {
          this.isWrong = true;
        }
      }
    },
  },
});
